import { render, staticRenderFns } from "./AnalyticsDashboard.vue?vue&type=template&id=37540a61&scoped=true"
import script from "./AnalyticsDashboard.vue?vue&type=script&lang=js"
export * from "./AnalyticsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37540a61",
  null
  
)

export default component.exports